import { render } from "./AppButtonRound.vue?vue&type=template&id=3b82e9b6"
import script from "./AppButtonRound.vue?vue&type=script&lang=js"
export * from "./AppButtonRound.vue?vue&type=script&lang=js"

import "./AppButtonRound.vue?vue&type=style&index=0&id=3b82e9b6&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__